import { render, staticRenderFns } from "./StudentIndex.vue?vue&type=template&id=38358644&"
import script from "./StudentIndex.vue?vue&type=script&lang=js&"
export * from "./StudentIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports